"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterimScreenOpenPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const InterimScreenRelaunchButton_1 = require("../../atoms/InterimScreenRelaunchButton/InterimScreenRelaunchButton");
const hocs_1 = require("../../hocs");
const hooks_1 = require("../../hooks");
const Route_1 = require("../../router/Route");
const InterimScreenTemplate_1 = require("../../templates/InterimScreenTemplate/InterimScreenTemplate");
const AuthProcess_1 = require("../../types/AuthProcess");
function InterimScreenOpenPage() {
    const auth = (0, hooks_1.useAuth)();
    const environment = (0, hooks_1.useAuthType)();
    const { state } = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const accessToken = (0, hooks_1.useSelector)(authState => authState === null || authState === void 0 ? void 0 : authState.accessToken);
    /**
     * Contains the timeout id for the navigation timeout
     */
    const navigationTimeoutId = (0, react_1.useRef)(null);
    const authProcess = state === null || state === void 0 ? void 0 : state.process;
    const onInterimScreenRelaunchButtonClick = (0, react_1.useCallback)(() => {
        switch (authProcess) {
            case AuthProcess_1.AuthProcess.SignIn:
                auth === null || auth === void 0 ? void 0 : auth.authenticate();
                break;
            case AuthProcess_1.AuthProcess.Register:
                auth === null || auth === void 0 ? void 0 : auth.signUp();
                break;
        }
    }, [auth, authProcess]);
    (0, react_1.useEffect)(() => {
        if (navigationTimeoutId.current === null) {
            navigationTimeoutId.current = window.setTimeout(() => {
                navigate(`${Route_1.Route.Base}/${Route_1.Route.InterimScreen}/${Route_1.Route.InterimScreenOpenTimeout}`, { replace: true });
            }, 20000);
        }
        return () => {
            if (navigationTimeoutId.current !== null) {
                window.clearTimeout(navigationTimeoutId.current);
                navigationTimeoutId.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run this effect once
    }, []);
    (0, react_1.useEffect)(() => {
        if (accessToken) {
            // Navigate to the loading page
            navigate(`${Route_1.Route.Base}/${Route_1.Route.InterimScreen}/${Route_1.Route.InterimScreenProcess}`, {
                state: { environment },
                replace: true,
            });
        }
    }, [accessToken, environment, navigate]);
    return ((0, jsx_runtime_1.jsx)(InterimScreenTemplate_1.InterimScreenTemplate, { environment: environment, title: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.authInProgress.title[authProcess][environment]), subtitle: (0, i18n_1.Localized)(i18n_1.Strings.auth.interimScreen.authInProgress.description[environment]), canBeClosed: true, "data-e2e": 'InterimScreenOpenPage_InterimScreenTemplate', children: (0, jsx_runtime_1.jsx)(InterimScreenRelaunchButton_1.InterimScreenRelaunchButton, { onClick: onInterimScreenRelaunchButtonClick, "data-e2e": 'InterimScreenOpenPage_InterimScreenRelaunchButton' }) }));
}
const InterimScreenOpenPageWithProvider = (0, hocs_1.withAuthProvider)(InterimScreenOpenPage);
exports.InterimScreenOpenPage = InterimScreenOpenPageWithProvider;
